import { render, staticRenderFns } from "./skyInputBtn.vue?vue&type=template&id=6fbe3c84&scoped=true"
import script from "./skyInputBtn.vue?vue&type=script&lang=js"
export * from "./skyInputBtn.vue?vue&type=script&lang=js"
import style0 from "./skyInputBtn.vue?vue&type=style&index=0&id=6fbe3c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbe3c84",
  null
  
)

export default component.exports